/* LBC · Halloween piñata — glam layer (2026-10-14, Cicely's styling notes).
   Styling only, on top of the existing sprites: lashes + blush on the PumpkinReaper head, a plum mini skirt on the
   pelvis, and the wicker basket re-lit as chrome. Nothing here is re-rendered — the lashes and the skirt are vectors,
   and the chrome is the existing hwp-p-basket.webp sprite with a filter plus a masked sheen, so it lines up exactly.

   On purpose this file does NOT touch assets/hw-pinata-2d.js. It only listens to the events that file already emits
   (lashbabe:pinata-ready / -break / -closed) and draws into the elements it already builds, so the taps, the claim,
   the break and the prize flow are untouched. Remove the "Glam styling" checkbox in the section and everything here
   is gone — the piñata falls back to exactly how it looked before.

   On the third tap everything here disappears with the body (Cicely, 14 Oct): the glam layers hide and the wicker
   basket is kept out of the burst, so no brown basket pops back in mid-flight. The products still fly.

   Geometry is in the render frame of the offline 3D render (1300 x 1976), the same frame hw-pinata-2d.js uses:
   · head box HB [430,692,388,462]   · rig box RIG [220,552,880,1353]   · basket [807,1106,277,392]
   Eye lids were measured off hwp-head0.webp: left lid (580,899)->(480,918), right lid (671,899)->(768,918). */
(function () {
  'use strict';
  var host = document.getElementById('hw-pinata');
  if (!host || host.dataset.glamStarted) return;
  if (/[?&]hwglam=0/.test(location.search)) return;              // emergency off-switch in the URL
  host.dataset.glamStarted = '1';

  var HB = [430, 692, 388, 462], RIG = [220, 552, 880, 1353], BASKET = [807, 1106, 277, 392];
  var nav = navigator;
  var LOW = (nav.hardwareConcurrency || 8) <= 4 || (nav.deviceMemory || 8) <= 2 ||
            !!(nav.connection && nav.connection.saveData) || /[?&]hwlow=1/.test(location.search);
  var BASE = (host.dataset.sprites || ((host.dataset.bundle || '').replace(/hw-pinata-2d\.js.*$/, '')));
  var BK = BASE + 'hwp-p-basket.webp?v=2d2';

  function pctIn(box, parent) {
    return 'left:' + ((box[0] - parent[0]) / parent[2] * 100).toFixed(3) + '%;top:' + ((box[1] - parent[1]) / parent[3] * 100).toFixed(3) +
           '%;width:' + (box[2] / parent[2] * 100).toFixed(3) + '%;height:' + (box[3] / parent[3] * 100).toFixed(3) + '%';
  }
  function svg(cls, vb) {
    return '<svg class="lb-glam ' + cls + '" viewBox="' + vb.join(' ') + '" aria-hidden="true" style="position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible">';
  }

  /* ---------- lashes: base follows the lid, tips sweep up and out, longest at the outer corner ---------- */
  function lashes(I, O, n, l0, l1) {
    var dx = O[0] - I[0], dy = O[1] - I[1], L = Math.sqrt(dx * dx + dy * dy), ux = dx / L, uy = dy / L, s = '';
    for (var k = 0; k < n; k++) {
      var u = k / (n - 1);
      var px = I[0] + dx * u * 0.95 + ux * 2, py = I[1] + dy * u * 0.95 + uy * 2 - 2;
      var len = l0 + (l1 - l0) * Math.pow(u, 0.75), lift = 1 + u * 0.9;
      var vx = 0.42 * ux, vy = 0.42 * uy - lift, vl = Math.sqrt(vx * vx + vy * vy); vx /= vl; vy /= vl;
      s += '<path d="M' + px.toFixed(1) + ' ' + py.toFixed(1) +
           ' Q' + (px + vx * len * 0.48).toFixed(1) + ' ' + (py + vy * len * 0.48).toFixed(1) +
           ' ' + (px + vx * len + ux * len * 0.40).toFixed(1) + ' ' + (py + vy * len + uy * len * 0.18 - len * 0.12).toFixed(1) +
           '" fill="none" stroke="#241019" stroke-linecap="round" stroke-width="' + (2.6 + u * 3.2).toFixed(1) + '"/>';
    }
    return s;
  }

  var SKIRT = 'M522 1386 C500 1432 480 1470 476 1496 C540 1516 712 1516 772 1496 C766 1470 748 1432 726 1386 Z';

  function dress() {
    var head = host.querySelector('.hwp-head'), rigI = host.querySelector('.hwp-rig-i');
    if (!head || !rigI || head.querySelector('.lb-glam')) return false;

    /* lashes + blush ride inside .hwp-head, so they follow every head state, the squash on each tap,
       and they vanish with the head when it breaks (the game hides .hwp-head itself). */
    if (0) head.insertAdjacentHTML('beforeend', svg('lb-lash', HB) +
      lashes([580, 899], [480, 918], 7, 17, 44) + lashes([671, 899], [768, 918], 7, 17, 44) + '</svg>');
    var bl = document.createElement('div');
    bl.className = 'lb-glam lb-blush';
    bl.setAttribute('aria-hidden', 'true');
    bl.style.cssText = 'position:absolute;inset:0;pointer-events:none;mix-blend-mode:soft-light;background:' +
      'radial-gradient(38% 27% at 15% 61%,rgba(255,80,125,.8),rgba(255,80,125,0) 70%),' +
      'radial-gradient(38% 27% at 82% 61%,rgba(255,80,125,.8),rgba(255,80,125,0) 70%)';
    head.appendChild(bl);

    /* mini skirt on the pelvis, inside the rig so it swings with every tap */
    if (0) rigI.insertAdjacentHTML('beforeend', svg('lb-skirt', RIG) +
      '<defs>' +
        '<linearGradient id="lbSk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#32163F"/><stop offset=".2" stop-color="#5C2E7C"/><stop offset=".65" stop-color="#48225F"/><stop offset="1" stop-color="#2A1038"/></linearGradient>' +
        '<linearGradient id="lbSkV" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#000" stop-opacity=".32"/><stop offset=".32" stop-color="#000" stop-opacity="0"/><stop offset=".6" stop-color="#fff" stop-opacity=".13"/><stop offset="1" stop-color="#000" stop-opacity=".36"/></linearGradient>' +
        '<clipPath id="lbSkC"><path d="' + SKIRT + '"/></clipPath>' +
      '</defs>' +
      '<path d="' + SKIRT + '" fill="url(#lbSk)"/>' +
      '<g clip-path="url(#lbSkC)"><rect x="460" y="1380" width="340" height="150" fill="url(#lbSkV)"/>' +
        '<path d="M566 1388 L548 1508 M624 1388 L624 1512 M682 1388 L700 1508" stroke="#000" stroke-opacity=".15" stroke-width="6" fill="none"/></g>' +
      '<path d="M476 1496 C540 1516 712 1516 772 1496" fill="none" stroke="#E3C27E" stroke-width="4.5" stroke-opacity=".8"/>' +
      '<rect x="518" y="1378" width="212" height="16" rx="8" fill="#E3C27E"/>' +
      '<rect x="518" y="1378" width="212" height="16" rx="8" fill="url(#lbSkV)"/>' +
    '</svg>');
return true; // 2026-10-19: chrome basket overlay off — new art has its own silver basket
    /* chrome basket: the same sprite, desaturated and re-lit, laid exactly over the baked-in wicker one */
    var pos = 'position:absolute;' + pctIn(BASKET, RIG) + ';pointer-events:none;';
    var ch = document.createElement('img');
    ch.className = 'lb-glam lb-chrome';
    ch.src = BK; ch.alt = ''; ch.decoding = 'async'; ch.draggable = false;
    ch.style.cssText = pos + 'filter:grayscale(1) brightness(1.18) contrast(1.9)';
    rigI.appendChild(ch);
    if (!LOW) {                                                   // the two blend layers are skipped on low-end phones
      var mask = '-webkit-mask:url(' + BK + ') center/100% 100% no-repeat;mask:url(' + BK + ') center/100% 100% no-repeat';
      var sh = document.createElement('div');
      sh.className = 'lb-glam lb-chrome';
      sh.setAttribute('aria-hidden', 'true');
      sh.style.cssText = pos + 'mix-blend-mode:screen;background:linear-gradient(100deg,rgba(255,255,255,0) 6%,rgba(255,255,255,.9) 22%,rgba(140,175,205,.15) 38%,rgba(255,255,255,0) 52%,rgba(255,255,255,.62) 72%,rgba(200,220,240,0) 90%);' + mask;
      rigI.appendChild(sh);
      var dk = document.createElement('div');
      dk.className = 'lb-glam lb-chrome';
      dk.setAttribute('aria-hidden', 'true');
      dk.style.cssText = pos + 'mix-blend-mode:multiply;background:linear-gradient(180deg,rgba(255,255,255,0) 52%,rgba(90,105,125,.55) 100%);' + mask;
      rigI.appendChild(dk);
    }
    return true;
  }

  /* ---------- hide everything the moment it breaks ---------- */
  function undress() {
    var i, g = host.querySelectorAll('.lb-glam');
    for (i = 0; i < g.length; i++) g[i].style.display = 'none';
    // and keep the wicker basket out of the burst, so it does not pop back in brown
    var t0 = Date.now();
    (function hunt() {
      var b = host.querySelector('.hwp-fx.f-basket');
      if (b) { b.style.display = 'none'; return; }
      if (Date.now() - t0 < 500) requestAnimationFrame(hunt);
    })();
  }

  document.addEventListener('lashbabe:pinata-break', undress, false);

  /* The game builds the rig when it opens (and again for a second try, if that ever comes back), so watch the host
     instead of dressing once. Cheap: it only fires when .hwp-rig / .hwp-head appear. */
  if (!dress() && window.MutationObserver) {
    var mo = new MutationObserver(function () { if (dress() && host.classList.contains('hw-broken')) undress(); });
    mo.observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('lashbabe:pinata-ready', function () { dress(); }, false);
})();
